import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';
import { gtm } from './services/gtm';

gtm.load();

// Prevent double mounting using global window object
declare global {
  interface Window {
    __PROMOTRAC_SHOP_MOUNTED__?: boolean;
  }
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

// Check if already mounted using window global
if (!window.__PROMOTRAC_SHOP_MOUNTED__) {
  // Mark as mounted globally
  window.__PROMOTRAC_SHOP_MOUNTED__ = true;

  const app = (
    <BrowserRouter basename={import.meta.env.VITE_BASE_URL_PATH}>
      <App />
    </BrowserRouter>
  );

  createRoot(rootElement).render(
    import.meta.env.DEV ? <StrictMode>{app}</StrictMode> : app
  );
}
